import '../../assets/styles/auth.scss'
import '../../assets/styles/pages.scss'
import laptop from '../../assets/images/pages/laptop.jpg'
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react'
import DownloadFileModal from '../../components/common/download-file-modal'
import { GlobalContext, handleError } from '../../context/Provider'
import henceforthApi, { CURRENCY_SYMBOL } from '../../utils/henceforthApi'
import PaginationLayout from '../../components/common/PaginationLayout'
import Spinner from '../../components/common/spinner'
import moment from 'moment'
import BreadCrumb from '../../components/common/BreadCrumb'
import { numberWithCommas } from '../../utils/validations'
import { ProductList } from './productInterface'
import { toast } from 'react-toastify'
import AllFilter from '../../components/common/AllFilter'
import COPY from "../../../src/assets/images/copy.png"
import { initLangData } from '../../utils/henceforthLanguage'
import SignedImage from '../../components/common/SignedImage'

const Products = () => {
    const match: any = useMatch('/products/:page')
    // const match2 = useMatch('/:storeId/products/:page');
    const { authState, loading, setLoading, authDispatch, language_data } = useContext(GlobalContext)
    let breadCrumbPath = [
        { name: `${language_data?.[authState.lang]?.common_home}`, url: `/`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_list}`, url: ``, active: 'not-allowed' }
    ]
    let Limit = 10;
    const location = useLocation();
    const newParam = new URLSearchParams(location.search);

    const [productList, setProductList] = useState({
        totalCount: 0,
        listing: [],
    } as ProductList)

    const [stockModal, setStockModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>(null);
    const [quantity, setQuantity] = useState('');

    // ---------- BULK UPLOAD STATE ----------
    const [bulkModal, setBulkModal] = useState(false);
    const [bulkFile, setBulkFile] = useState<File | null>(null);
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    // ADDED: holds the summary + skipped_details returned from the bulk upload API,
    // matching the pattern used for the Store bulk upload
    const [uploadResult, setUploadResult] = useState<{
        total_uploaded: number;
        total_created: number;
        total_skipped: number;
        skipped_details: { row: number; name?: string; reason: string }[];
    } | null>(null);
    const [showResultModal, setShowResultModal] = useState(false); // ADDED

    const router = useNavigate();

    const [sortField, setSortField] = useState(newParam.get("sort_by") || "");
    const [sortOrder, setSortOrder] = useState(newParam.get("sort_order") || "asc");

    const applySort = (field: string, order: string) => {
        setSortField(field);
        setSortOrder(order);

        const params = new URLSearchParams(location.search);
        if (order) {
            params.set("sort_by", field);
            params.set("sort_order", order);
        } else {
            params.delete("sort_by");
            params.delete("sort_order");
        }

        const currentPage = match?.params?.page || "1"; // CHANGED: match?.params.page -> match?.params?.page
        router(`/products/${currentPage}?${params.toString()}`);
    };

    const onSortAsc = (field: string) => {
        if (sortField === field && sortOrder === "asc") {
            applySort("", "");
        } else {
            applySort(field, "asc");
        }
    };

    const onSortDesc = (field: string) => {
        if (sortField === field && sortOrder === "desc") {
            applySort("", "");
        } else {
            applySort(field, "desc");
        }
    };




    const SortIcon = ({ field }: { field: string }) => (
        <span
            className="ms-1"
            style={{ display: "inline-flex", gap: "4px", verticalAlign: "middle" }}
        >
            <i
                className="fa fa-arrow-up"
                style={{
                    fontSize: "13px",
                    cursor: "pointer",
                    color: sortField === field && sortOrder === "asc" ? "#29ABE2" : "#b0b8c1"
                }}
                onClick={() => onSortAsc(field)}
            />
            <i
                className="fa fa-arrow-down"
                style={{
                    fontSize: "13px",
                    cursor: "pointer",
                    color: sortField === field && sortOrder === "desc" ? "#e03131" : "#b0b8c1"
                }}
                onClick={() => onSortDesc(field)}
            />
        </span>
    );

    const exportData = async (startDate: number, endDate: number) => {
        try {
            const apiRes = await henceforthApi.Product.export(startDate, endDate)
            const data = apiRes?.data?.data // CHANGED: added optional chaining
            const rows = [
                [
                    "Sr.",
                    "Product Id",
                    "Category Level 1",
                    "Category level 2",
                    "Brand",
                    "Store Name",
                    "Product Name",
                    "Product Price",
                    "Quantity",
                ],
            ];

            if (Array.isArray(data)) {
                data.map((res: any, index: any) => {
                    return rows.push([
                        index,
                        res?.prodct_id,
                        res?.category_id?.name,
                        res?.subcategory_id?.name,
                        res?.brand_id?.name,
                        res?.store_name || "N/A",
                        res?.name,
                        res?.price,
                        res?.quantity,
                    ])
                })
            }
            console.log(rows);
            let csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `product_${moment().valueOf()}.csv`);
            document.body.appendChild(link); // Required for FF
            link.click(); // This will download the data file named "my_data.csv".
            let closeModal = document.getElementById("closeModal");
            if (closeModal) {
                closeModal.click();
            }
        } catch (error) {
            handleError(error, 'active', authDispatch);
        }

    }
    const copyText = (id: string) => {
        if (id) {
            navigator?.clipboard?.writeText(id)
            toast.success(`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_id} ${language_data?.[authState.lang]?.common_copy} ${language_data?.[authState.lang]?.common_successfull}`)
        }
    }
    const productListing = async () => {

        setLoading(true)
        try {
            // CHANGED: guard against NaN when match/page is missing — fall back to page 1 (index 0)
            const currentPageNum = Number(match?.params?.page);
            const pageIndex = !isNaN(currentPageNum) && currentPageNum > 0 ? currentPageNum - 1 : 0;

            let res = (await henceforthApi.Product.getProductList('', pageIndex, Limit, newParam.toString())).data
            setProductList({
                ...productList,
                totalCount: res?.total_count, // CHANGED: optional chaining
                listing: res?.data ?? [], // CHANGED: optional chaining + fallback
            })

        } catch (err: any) {
            // console.log("err", err.response.body.error_description);
            if (newParam.has('product_id')) {
                toast.warn(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_search} ${language_data?.[authState.lang]?.common_proper} ${language_data?.[authState.lang]?.common_id}`)
                setProductList({
                    ...productList,
                    listing: [],
                })
            }
            handleError(err, '', authDispatch);
        } finally {
            setLoading(false)
        }
    }

    // useEffect(() => {
    //     productListing();

    // }, [match?.params.page, newParam.get("search"), newParam.get("product_id"), newParam.get("min_price"), newParam.get("max_price")])
    useEffect(() => {
        productListing();
    }, [match?.params?.page, location.search]) // CHANGED: match?.params.page -> match?.params?.page

    const handleManageStock = (product: any) => {
        setSelectedProduct(product);
        setQuantity('');
        setStockModal(true);
    };

    const submitStock = async () => {
        try {
            if (!quantity || Number(quantity) < 0) {
                return toast.error("Please enter valid quantity");
            }

            setLoading(true);

            await henceforthApi.Store.manageProductStock(
                selectedProduct?._id,
                {
                    quantity: Number(quantity)
                }
            );

            toast.success("Stock updated successfully");

            setStockModal(false);
            productListing();

        } catch (error: any) {
            handleError(error, '', authDispatch);
        } finally {
            setLoading(false);
        }
    };

    // ---------- BULK UPLOAD FUNCTIONS ----------
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setBulkFile(e.target.files[0]);
        }
    };

    const handleBulkUpload = async () => {
        if (!bulkFile) {
            toast.error("Please select a CSV file");
            return;
        }

        // Validate file type
        if (!bulkFile.name.endsWith('.csv') && !bulkFile.type.includes('csv')) {
            toast.error("Only CSV files are allowed");
            return;
        }

        const formData = new FormData();
        formData.append('file', bulkFile);

        setUploading(true);
        try {
            const sellerId = authState?._id; // Get seller ID from auth
            const response: any = await henceforthApi.Product.addBulkProduct(sellerId, formData);
            const body = response?.body ?? response?.data; // CHANGED: superagent uses .body, not .data

            if (body?.success === false) {
                toast.error(body?.message || "Bulk upload failed"); // CHANGED: don't show success toast on success:false
            } else {
                toast.success(body?.message || "Bulk upload successful");
            }

            // ADDED: capture summary + skip reasons so the user can see why rows failed
            setUploadResult({
                total_uploaded: body?.total_uploaded ?? 0,
                total_created: body?.total_created ?? 0,
                total_skipped: body?.total_skipped ?? 0,
                skipped_details: body?.skipped_details ?? []
            });

            // Refresh product list
            productListing();
            // Close modal and reset
            setBulkModal(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            // ADDED: only pop the skip report if something was actually skipped
            if ((body?.skipped_details?.length ?? 0) > 0) {
                setShowResultModal(true);
            }
        } catch (error: any) {
            // CHANGED: superagent puts the parsed JSON body on error.response.body
            // (axios would use error.response.data) — check both to be safe.
            const data =
                error?.response?.body ??
                error?.response?.data ??
                error?.data;

            if (data?.skipped_details?.length || data?.total_uploaded) {
                setUploadResult({
                    total_uploaded: data?.total_uploaded ?? 0,
                    total_created: data?.total_created ?? 0,
                    total_skipped: data?.total_skipped ?? 0,
                    skipped_details: data?.skipped_details ?? []
                });
                setBulkModal(false); // CHANGED: avoid two modals open at once
                setShowResultModal(true);
            }

            handleError(error, '', authDispatch);
        } finally {
            setUploading(false);
        }
    };
    // ADDED: close handler for the results modal
    const closeResultModal = () => {
        setShowResultModal(false);
        setUploadResult(null);
    };

    return (
        <Fragment>
            {/* breadcrum  */}
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            {/* Page  */}
            <div className='page-spacing'>
                <section className='products'>
                    <div className='product-detail-box'>
                        <AllFilter />
                        <div className="common-card">
                            <div className="common-card-title d-flex justify-content-between align-items-center gap-2 flex-column flex-sm-row">
                                <h5>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_listing} {language_data?.[authState.lang]?.common_deatil}</h5>
                                {authState?.role !== 'store' && <div className="d-flex gap-2 flex-wrap align-items-center">

                                    <button
                                        className="btn btn-white btn-sm"
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = `${process.env.PUBLIC_URL}/assets/csv/Product.csv`;
                                            link.download = 'Product.csv';
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    >
                                        <i className="fa fa-download me-1"></i>Download Sample
                                    </button>


                                    <Link className="btn btn-white btn-sm" to={authState?.is_admin_verified === 'pending' || authState?.is_admin_verified === 'reject' ? "#" : "/product/add"} onClick={(e) => {
                                        if (authState?.is_admin_verified === 'pending') {
                                            e.preventDefault();
                                            toast.error("Your account is pending for admin verification.");
                                        }
                                        if (authState?.is_admin_verified === 'reject') {
                                            e.preventDefault();
                                            toast.error("Your account is rejected for admin verification.");
                                        }
                                    }}> <i className="fa fa-plus me-1"></i>{language_data?.[authState.lang]?.common_add}</Link>

                                    {/* BULK UPLOAD BUTTON */}
                                    <button
                                        className="btn btn-white btn-sm"
                                        onClick={() => {
                                            if (authState?.is_admin_verified === 'pending') {
                                                toast.error("Your account is pending for admin verification.");
                                                return;
                                            }
                                            if (authState?.is_admin_verified === 'reject') {
                                                toast.error("Your account is rejected for admin verification.");
                                                return;
                                            }
                                            setBulkModal(true);
                                        }}
                                    >
                                        <i className="fa fa-upload me-1"></i>
                                        Bulk Upload
                                    </button>

                                    {/* ADDED: quick re-open of the last upload's skip report */}
                                    {uploadResult && uploadResult.skipped_details.length > 0 && (
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => setShowResultModal(true)}
                                        >
                                            <i className="fa fa-exclamation-triangle me-1" />
                                            View Skip Report ({uploadResult.skipped_details.length})
                                        </button>
                                    )}
                                </div>}
                            </div>
                            <div className="common-card-content">
                                {/* table */}
                                <div className='data-list-table table-responsive mb-3 text-center'>
                                    {loading ? <Spinner color={"text-success"} />
                                        :
                                        <table className="table table-striped align-middle text-center">
                                            <thead className=''>
                                                <tr>
                                                    <th>{language_data?.[authState.lang]?.common_sr_no}</th>
                                                    <th>{language_data?.[authState.lang]?.common_product}{language_data?.[authState.lang]?.common_id} </th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._1}</th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._2}</th>
                                                    <th>{language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._3}</th>
                                                    <th>{language_data?.[authState.lang]?.common_brand} <SortIcon field="brand_name" /></th>

                                                    <th>{language_data?.[authState.lang]?.common_store || "Store_Name"}</th>
                                                    <th>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_name} <SortIcon field="product_name" /></th>
                                                    <th>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_price}</th>
                                                    <th>{language_data?.[authState.lang]?.common_quantity} <SortIcon field="quantity" /></th>
                                                    <th>{language_data?.[authState.lang]?.common_action}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {Array.isArray(productList.listing) && productList.listing.length ? productList.listing.map((res, index: number) =>
                                                    <tr key={res?._id}>
                                                        <td> {match?.params?.page === "0" // CHANGED: match?.params.page -> match?.params?.page
                                                            ? index + 1
                                                            : (Number(match?.params?.page) - 1) * Limit + (index + 1)}</td> {/* CHANGED */}
                                                        <td>{res?.prodct_id ? res?.prodct_id : `${language_data?.[authState.lang]?.common_not_available}`} <img src={COPY} style={{ width: 15 }} onClick={() => copyText(res?.prodct_id)} role="button" data-toggle="tooltip" title={`${res?.prodct_id}`} /></td> {/* CHANGED: res.prodct_id -> res?.prodct_id (both places) */}
                                                        <td>{res?.category_id ? res?.category_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.subcategory_id
                                                            ? res?.subcategory_id
                                                                ?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.sub_subcategory_id ? res?.sub_subcategory_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.brand_id ? res?.brand_id?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.store_name ? res?.store_name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td className='product-image-table'>
                                                            <SignedImage
                                                                className='me-2'
                                                                src={Array.isArray(res?.images) && res?.images?.length ? res?.images[0] : ''}
                                                                alt={res?.images?.[0] || 'Product'} // CHANGED: res.images?.[0] -> res?.images?.[0]
                                                                fallback={laptop}
                                                                size="small"
                                                            />
                                                            {res?.name ? res?.name : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td><b>{CURRENCY_SYMBOL}</b> {res?.price ? numberWithCommas(res?.price) : `${language_data?.[authState.lang]?.common_not_available}`}</td>
                                                        <td>{res?.quantity !== 0 ? res?.quantity : `${language_data?.[authState.lang]?.common_out_of_stock}`}</td>
                                                        <td>
                                                            <div className="btn-group gap-2">
                                                                <Link className="btn btn-white btn-sm" to={authState?.is_admin_verified === 'pending' || authState?.is_admin_verified === 'reject' ? '#' : `/product/${res?._id}${res?.store_id ? `?store_id=${res.store_id}` : ''}`} onClick={(e) => {
                                                                    if (authState?.is_admin_verified === 'pending') {
                                                                        e.preventDefault();
                                                                        toast.error("Your account is pending for admin verification.");
                                                                    }
                                                                    if (authState?.is_admin_verified === 'reject') {
                                                                        e.preventDefault();
                                                                        toast.error("Your account is rejected for admin verification.");
                                                                    }
                                                                }}> <i className="fa fa-eye me-1"></i>{language_data?.[authState.lang]?.common_view}</Link>

                                                                {authState?.role !== 'store' && <Link
                                                                    className="btn btn-white btn-sm"
                                                                    to={
                                                                        authState?.is_admin_verified === 'pending' ||
                                                                            authState?.is_admin_verified === 'reject'
                                                                            ? '#'
                                                                            : `/product/${res?._id}/edit${res?.store_id ? `?store_id=${res.store_id}` : ''}`
                                                                    } 
                                                                
                                                                    onClick={(e) => {
                                                                        if (authState?.is_admin_verified === 'pending') {
                                                                            e.preventDefault();
                                                                            toast.error("Your account is pending for admin verification.");
                                                                        }
                                                                        if (authState?.is_admin_verified === 'reject') {
                                                                            e.preventDefault();
                                                                            toast.error("Your account is rejected for admin verification.");
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fa fa-pencil me-1"></i>
                                                                    {language_data?.[authState.lang]?.common_edit}
                                                                </Link>}
                                                                {authState?.role === 'store' && (
                                                                    <Link
                                                                        className="btn btn-white btn-sm"
                                                                        to="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleManageStock(res);
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-cubes me-1"></i>
                                                                        Manage Stock
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                                    : <tr className='text-center'><td colSpan={9}>{language_data?.[authState.lang]?.common_no_data_found}</td></tr>}



                                            </tbody>
                                        </table>}
                                </div>
                                {/* pagination  */}
                                <div className='dashboad-pagination-box'>
                                    <PaginationLayout
                                        data={productList.listing}
                                        count={productList.totalCount}
                                        limit={Number(Limit)}
                                        page={Number(match?.params?.page)} // CHANGED: match?.params.page -> match?.params?.page
                                    />
                                </div>
                            </div>

                            {/* Stock Modal (unchanged) */}
                            {stockModal && (
                                <div
                                    className="modal fade show"
                                    style={{
                                        display: 'block',
                                        backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">

                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    Manage Stock
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setStockModal(false)}
                                                />
                                            </div>

                                            <div className="modal-body">

                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Quantity
                                                    </label>

                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={quantity}
                                                        onChange={(e) =>
                                                            setQuantity(e.target.value)
                                                        }
                                                        min={0}
                                                        placeholder="Enter Quantity"
                                                    />
                                                </div>

                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => setStockModal(false)}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn btn-theme"
                                                    onClick={submitStock}
                                                >
                                                    Update Stock
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* BULK UPLOAD MODAL */}
                            {bulkModal && (
                                <div
                                    className="modal fade show"
                                    style={{
                                        display: 'block',
                                        backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">

                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    Bulk Upload Products
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => {
                                                        setBulkModal(false);
                                                        setBulkFile(null);
                                                        if (fileInputRef.current) fileInputRef.current.value = '';
                                                    }}
                                                />
                                            </div>

                                            <div className="modal-body">

                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Select CSV File
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".csv"
                                                        onChange={handleFileChange}
                                                        ref={fileInputRef}
                                                    />
                                                    <small className="text-muted">
                                                        Only CSV files are allowed. The file must contain required columns.
                                                    </small>
                                                </div>

                                                {bulkFile && (
                                                    <div className="alert alert-info">
                                                        <i className="fa fa-file-text-o me-2"></i>
                                                        {bulkFile.name} ({(bulkFile.size / 1024).toFixed(2)} KB)
                                                    </div>
                                                )}

                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        setBulkModal(false);
                                                        setBulkFile(null);
                                                        if (fileInputRef.current) fileInputRef.current.value = '';
                                                    }}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn btn-theme"
                                                    onClick={handleBulkUpload}
                                                    disabled={uploading || !bulkFile}
                                                >
                                                    {uploading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" />
                                                            Uploading...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-upload me-1" />
                                                            Upload
                                                        </>
                                                    )}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ADDED: Skip Report Modal — same pattern as Store bulk upload */}
                            {showResultModal && uploadResult && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    <i className="fa fa-exclamation-triangle text-warning me-2" />
                                                    Bulk Upload Report
                                                </h5>
                                                <button type="button" className="btn-close" onClick={closeResultModal} />
                                            </div>
                                            <div className="modal-body">
                                                <div className="d-flex gap-3 mb-3 flex-wrap">
                                                    <div className="border rounded p-2 px-3 text-center flex-fill">
                                                        <div className="fw-bold fs-5">{uploadResult.total_uploaded}</div>
                                                        <small className="text-muted">Uploaded</small>
                                                    </div>
                                                    <div className="border rounded p-2 px-3 text-center flex-fill">
                                                        <div className="fw-bold fs-5 text-success">{uploadResult.total_created}</div>
                                                        <small className="text-muted">Created</small>
                                                    </div>
                                                    <div className="border rounded p-2 px-3 text-center flex-fill">
                                                        <div className="fw-bold fs-5 text-danger">{uploadResult.total_skipped}</div>
                                                        <small className="text-muted">Skipped</small>
                                                    </div>
                                                </div>

                                                {uploadResult.skipped_details.length > 0 ? (
                                                    <div className="table-responsive" style={{ maxHeight: "350px", overflowY: "auto" }}>
                                                        <table className="table table-sm table-bordered align-middle mb-0">
                                                            <thead className="table-light" style={{ position: "sticky", top: 0 }}>
                                                                <tr>
                                                                    <th>Row</th>
                                                                    <th>Name</th>
                                                                    <th>Reason</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {uploadResult.skipped_details.map((detail, idx) => (
                                                                    <tr key={`${detail.row}-${idx}`}>
                                                                        <td>{detail.row}</td>
                                                                        <td>{detail.name || "—"}</td>
                                                                        <td className="text-danger">{detail.reason}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <p className="text-muted mb-0">No rows were skipped.</p>
                                                )}
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-secondary" onClick={closeResultModal}>
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <DownloadFileModal exportData={useMemo(() => exportData, [])} />
        </Fragment>
    )
}
export default Products;